import React from "react";
import { Link } from "react-router-dom";
import { Template } from "../models/Template";
import { loadTemplatesPage } from "../api/Template";
import { PaginatedTable } from "../components/PaginatedTable";
import { Breadcrumb } from "../components/Breadcrumb";
import { Map } from "../models/Map";
import { OwnershipIndicator } from "../components/OwnershipIndicator";

const TABLE_COLUMNS = [
  {
    id: "name",
    name: "Name",
    selector: (template: Template) => template.name,
    sortable: true,
  },
  {
    id: "game_count",
    name: "Games",
    selector: (template: Template) => template.game_count || "",
    sortable: true,
  },
  {
    id: "block_count",
    name: "Blocks",
    selector: (template: Template) => template.block_count || "",
    sortable: true,
  },
  {
    name: "Owned By You",
    cell: (map: Map) => <OwnershipIndicator item={map} />,
  },
  {
    name: "View",
    button: true,
    sortable: false,
    cell: (template: Template) => (
      <Link to={`/templates/${template.id}`} className="btn btn-primary">
        <i className="fa-solid fa-file-pen"></i>
      </Link>
    ),
  },
];

export const TemplatesPage = () => {
  return (
    <>
      <Breadcrumb items={[{ text: "Templates", link: "/templates" }]} />
      <div className="row">
        <div className="col-12">
          <div className="card">
            <div className="card-header pb-0">
              <div className="float-end">
                <Link to="/templates/new" className="btn btn-primary">
                  New Template <i className="fa-solid fa-circle-plus"></i>
                </Link>
              </div>
              <h5 className="card-title mb-0">Templates</h5>
            </div>
            <div className="card-body">
              <PaginatedTable
                columns={TABLE_COLUMNS}
                loadPage={loadTemplatesPage}
                filterable
                defaultSortField="name"
                defaultSortAsc
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
